import { useNavigate } from 'react-router-dom';
import { Button } from '@/shared/components/ui/button';
import { Card } from '@/shared/components/ui/card';
import { CheckCircle2, ArrowRight } from 'lucide-react';

export function TransitionMessage() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-64px)] lg:min-h-screen p-4">
      <Card className="max-w-2xl w-full p-10 text-center">
        <div className="mb-6 flex justify-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <CheckCircle2 className="text-green-600" size={32} />
          </div>
        </div>

        <h1 className="text-3xl font-semibold text-gray-900 mb-4">
          We've got what we need
        </h1>
        
        <p className="text-lg text-gray-700 mb-3 leading-relaxed">
          Based on where you are in your care journey, we're going to build a personalized care plan for you.
        </p>
        
        <p className="text-gray-600 mb-8">
          Let's start by connecting you with providers in the bQuest network who specialize in your situation.
        </p>

        {/* Mini Flow Preview */}
        <div className="flex items-center justify-center gap-4 mb-10 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#3d7872] text-white rounded-full flex items-center justify-center font-semibold">
              1
            </div>
            <span className="text-gray-700">Match Providers</span>
          </div>
          
          <ArrowRight className="text-gray-400" size={20} />
          
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gray-200 text-gray-600 rounded-full flex items-center justify-center font-semibold">
              2
            </div>
            <span className="text-gray-600">Build Plan</span>
          </div>
          
          <ArrowRight className="text-gray-400" size={20} />
          
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gray-200 text-gray-600 rounded-full flex items-center justify-center font-semibold">
              3
            </div>
            <span className="text-gray-600">Next Steps</span>
          </div>
        </div>

        <Button 
          onClick={() => navigate('/detailed-care-navigator/matching/0')}
          className="bg-[#3d7872] hover:bg-[#2d6862] text-white px-8 py-6 text-lg rounded-xl"
          size="lg"
        >
          Let's Get Started
        </Button>
      </Card>
    </div>
  );
}
